import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/mom/work-order/{id}/reject`。body：`rejectReason`、`updatedAt`。 */
export async function rejectWorkOrder(id, payload) {
  const { data: raw } = await request.post(
    `/mom/work-order/${id}/reject`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
